import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  time: {
    color: palette.shades[700],
    marginBottom: '4px'
  },
  notificationsList: {
    marginTop: '18px',
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  notification: {
    padding: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderTop: "1px solid ".concat(palette.shades[300]),
    '& .MuiButton-root': {
      flexShrink: '0'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      padding: '18px 0',
      '& .MuiButton-root': {
        marginLeft: '20px'
      }
    }
  }
});
export default useStyles;